<template>
        <div class="quill-editor"></div>
</template>
<script>
import Typograf from "typograf";
import Quill from 'quill'

export default {
    name: 'VueEditor',
    props: {
        value: String,
        placeholder: {
            type: String,
            required: false,
            default: ""
        },

        config: {
            type: Object,
            required: false,
            default: function () {
                return {}
            },
        },
    },
    data: function () {
        return {
            content: '',
            tp: null,
            inProcess: false,
            defaultModules: {
                toolbar: {
                    container: [
                        [{'list': 'bullet'}, 'clean', 'textLowerCase'],
                    ],
                    handlers: {
                        textLowerCase () {
                            let range = this.quill.getSelection();
                            let text = this.quill.getText(range.index, range.length);
                            text = text.toLowerCase();

                            if (range.length) {
                                this.quill.deleteText(range.index, range.length, 'api');
                            }
                            this.quill.insertText(range.index, text, 'api');
                            this.quill.setSelection(range.index + text.length, 0);
                        }
                    }
                }
            },

            quillEditor: null,
        }
    },
    mounted: function () {
        this.$nextTick(() => {
            this.initialize();
        });
    },
    beforeDestroy: function () {
        this.quillEditor = null;
    },
    watch: {
        value: function (newVal, oldVal) {
            if (this.quillEditor) {
                if (!!newVal && newVal !== this.content) {

                    this.content = newVal;
                     // setting dangerously html
                    this.quillEditor.clipboard.dangerouslyPasteHTML(newVal);
                } else if (!newVal) {
                    this.quillEditor.setText('');
                }
            }
        },
    },
    methods: {
        initialize: function () {
            this.initTypograf();
            if (this.$el) {
                var self = this;

                function customizer(objValue, srcValue) {
                    return _.isUndefined(objValue) ? srcValue : objValue;
                }

                var defaults = _.partialRight(_.assignInWith, customizer);

                let quillConfig =  defaults(self.config,
                    {
                        modules: {},
                        placeholder: self.placeholder ? self.placeholder : 'Описание',
                        formats: [
                            'list',
                            'indent'
                        ],
                        readOnly: false,
                        theme: 'snow',
                        boundary: document.body,
                    }
                )

                quillConfig.modules.toolbar = defaults(quillConfig.modules.toolbar || {},
                    self.defaultModules.toolbar
                )
                self.quillEditor = new Quill(self.$el, quillConfig);
                setTimeout(function request() {
                    self.quillEditor.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
                        return self.customMatcherElement(node, delta);
                    });
                }, 500);


                // set editor content
                if (self.value || self.content) {
                    // setting dangerously html
                    self.quillEditor.root.innerHTML = self.value || self.content
                }
                // mark model as touched if editor lost focus
                self.quillEditor.on('selection-change', function (range) {
                    if (!range) {

                        var deltaQuillContent =  self.quillEditor.getContents();
                        var deltaTypoContent = _.cloneDeep(deltaQuillContent);
                        var delArrInx = [];
                        let deltaLength = deltaTypoContent.ops.length;
                        deltaTypoContent.map(function (operation, index) {
                            if (typeof operation.insert == 'string') {
                                if (operation.insert.length > 2 && operation.insert.indexOf("\n") === 0) {
                                    if (index === 0 || index > 0 &&
                                        deltaTypoContent.ops[index - 1].attributes !== undefined &&
                                        deltaTypoContent.ops[index - 1].attributes.list !== undefined
                                    ) {
                                        operation.insert = operation.insert.substring(1)
                                    }
                                }


                                if (index>0 &&
                                    deltaTypoContent.ops[index].attributes !== undefined &&
                                    deltaTypoContent.ops[index].attributes.list !== undefined &&
                                    deltaTypoContent.ops[index-1].insert.lastIndexOf("\n")+1 ===  deltaTypoContent.ops[index-1].insert.length
                                ){
                                    delArrInx.push(index)
                                }

                                if (quillConfig.eventsOnBlur) {
                                    operation.insert = self.tp.execute(operation.insert);
                                }
                            }
                            return operation;
                        }.bind(this));

                        if(delArrInx.length>0){
                            deltaTypoContent.ops = deltaTypoContent.ops.filter((value, index) => {
                                return delArrInx.indexOf(index) === -1
                            });
                        }

                        self.inProcess = false;

                        if(deltaTypoContent.ops.length && deltaTypoContent.ops[deltaTypoContent.ops.length-1].insert !== undefined){
                          deltaTypoContent.ops[deltaTypoContent.ops.length-1].insert = deltaTypoContent.ops[deltaTypoContent.ops.length-1].insert.replace(/[ \t]+\n/g, "\n");
                        }

                        self.quillEditor.updateContents(deltaQuillContent.diff(deltaTypoContent), Quill.sources.API);

                        if (quillConfig.eventsOnBlur) {
                            self.content = self.tp.execute(self.$el.children[0].innerHTML);
                        }

                        self.$emit('blur', self.quillEditor)
                    } else {
                        self.$emit('focus', self.quillEditor)
                    }
                })
                // update model if text changes
                self.quillEditor.on('text-change', _.debounce(function (delta, oldDelta, source) {

                    var html = self.$el.children[0].innerHTML;
                    var text = self.quillEditor.getText();
                    if (html == '<p><br></p>') {
                        html = '';
                    }
                    var deltaQuillContent =  self.quillEditor.getContents();
                    var deltaTypoContent = _.cloneDeep(deltaQuillContent);
                    let deltaLength = deltaTypoContent.ops.length;

                    deltaTypoContent.map(function (operation, index) {
                        if (typeof operation.insert == 'string' && !quillConfig.eventsOnBlur) {
                            operation.insert = self.tp.execute(operation.insert);
                        }
                        return operation;
                    }.bind(this));

                    self.quillEditor.updateContents(deltaQuillContent.diff(deltaTypoContent), Quill.sources.API);

                    self.content = !quillConfig.eventsOnBlur ? self.tp.execute(html) : html;

                    self.$emit('input',  self.content );
                },400));

                self.quillEditor.on('text-change', function (delta, oldDelta, source) {
                    self.inProcess = true;
                    let listChanged = delta.filter((op) => (op.attributes !== undefined && op.attributes.list !== undefined)).length;
                    if (listChanged) {
                        let Delta = Quill.import('delta');
                        var deltaBefore = self.quillEditor.getContents();
                        var deltaNew = new Delta();
                        deltaBefore.eachLine((line, attr, i) => {
                            var d = line;
                            if (attr.list !== undefined) {
                                var dText = d
                                    .filter((op) => typeof op.insert === 'string')
                                    .map((op) => op.insert)
                                    .join('');

                                var prefix = dText.match(/^([-*•·▪▫‣◦+—.)\s]|(\d{1,2}[\)\.]))+/ig) || [''];
                                d = d.slice(prefix[0].length);
                            }

                            d.insert('\n', attr);
                            deltaNew = deltaNew.concat(d);
                        });
                        deltaNew.forEach((op) => {
                            if (op.attributes !== undefined && op.attributes.list !== undefined) {
                                op.attributes.list = 'bullet';
                            }
                        })
                        self.quillEditor.updateContents(deltaBefore.diff(deltaNew), 'api');
                    }

                });
                // 广播事件
                self.$emit('ready', self.quillEditor)
            }
        },
        initTypograf () {
            this.tp =  new Typograf({locale: 'ru'});
            this.tp.enableRule('common/nbsp/replaceNbsp');

            if (!this.config.eventsOnBlur) {
                this.tp.disableRule('common/space/delRepeatSpace');
            }

            this.tp.disableRule('common/space/replaceTab');
            this.tp.disableRule('common/space/delRepeatN');
            this.tp.disableRule('common/space/delLeadingBlanks');
            this.tp.disableRule('common/space/delTrailingBlanks');
            this.tp.disableRule('ru/money/ruble');
            this.tp.disableRule('common/space/trimRight');
            this.tp.disableRule('common/space/trimLeft');
            this.tp.disableRule('common/html/nbr');
            this.tp.disableRule('common/nbsp/afterNumber');
            this.tp.disableRule('common/nbsp/afterParagraph');
            this.tp.disableRule('common/nbsp/afterShortWord');
            this.tp.disableRule('common/nbsp/beforeShortLastWord');
        },
        customMatcherList: function (node, delta) {
            var Delta = Quill.import('delta');
            return delta.compose(new Delta().retain(delta.length(), {list: true}));
        },
        customMatcherElement: function (node, delta) {
            var Delta = Quill.import('delta');
            var self = this;

            if (node.tagName === 'TR') {
                return new Delta().insert('\n').concat(delta);
            }
            if (node.tagName === 'TD') {
                return new Delta().insert(' ').concat(delta);
            }
            if (node.tagName === 'math') {
                return new Delta().insert(' ');
            }
            if (!delta.ops[0]) {
                return new Delta().insert('');
            }

            let res = new Delta(delta).map(function (op) {
                if (typeof op.insert === 'string') {
                    if (op.attributes) {
                        if (op.attributes.list) {
                            op.attributes.list = 'bullet';
                        }
                    }
                    return op;
                } else {
                    return {insert: ''};
                }
            });
            return new Delta(res);
        },
    },
}
</script>
<style>
.quill-editor .ql-editor {
    color: #000;
    width: 100%;
    padding: 3px;
    font-size: 14px;
    line-height: 17px;
}

.quill-editor .ql-blank::before {
    font-style: normal !important;
    left: 3px !important;
    font-size: 14px !important;
    color: rgba(162, 158, 158, 0.6) !important;
}

.ql-container {
    font-size: 14px !important;
}

.ql-editor p {
    margin: 0 0 9px !important;
}
.ql-editor ol, .ql-editor ul {
    margin-top: 0;
    margin-bottom: 9px;
    padding-left: 40px !important;
}
.ql-editor ul li {
    padding: unset !important;
}
.ql-editor li:not(.ql-direction-rtl)::before {
    font-size: 16px
}
.ql-editor li:not(.ql-direction-rtl)::before {
    /*margin-right: 0.5em !important;*/
}
.ql-editor .ql-indent-1:not(.ql-direction-rtl) {
    padding-left: 40px !important;
}
.ql-editor .ql-indent-2:not(.ql-direction-rtl) {
    padding-left: 80px !important;
}
.ql-editor .ql-indent-3:not(.ql-direction-rtl) {
    padding-left: 120px !important;
}
.ql-editor .ql-indent-4:not(.ql-direction-rtl) {
    padding-left: 160px !important;
}
.ql-toolbar .ql-formats:nth-child(2) {
    float: right;
    padding-right: 0;
    margin-right: 0;
}

.ql-textLowerCase:after {
    content: "A→а";
    /*padding-left: 10px;*/
}

.ql-textToList:after {
    content: "\f0ca";
    padding-right: 10px;
    font-size: 14px;
    margin-top: -2px;
}

.ql-toolbar.ql-snow {
    border: 1px solid #b0b4b4;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    height: 26px;
    padding: 2px;
}

.ql-toolbar.ql-snow .ql-formats {
    margin-right: 15px;
}

.ql-toolbar.ql-snow .ql-picker-label {
    border: 1px solid transparent;
}

.ql-toolbar.ql-snow .ql-picker-options {
    border: 1px solid transparent;
    box-shadow: rgba(0, 0, 0, 0.2) 0 2px 8px;
}

.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {
    border-color: #ccc;
}

.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
    border-color: #ccc;
}

.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,
.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {
    border-color: #000;
}

.ql-toolbar.ql-snow + .ql-container.ql-snow {
    border-top: 0px;
}

.ql-snow .ql-tooltip {
    background-color: #fff;
    border: 1px solid #ccc;
    box-shadow: 0px 0px 5px #ddd;
    color: #444;
    padding: 5px 12px;
    white-space: nowrap;
}

.ql-snow .ql-tooltip::before {
    content: "Visit URL:";
    line-height: 26px;
    margin-right: 8px;
}

.ql-snow .ql-tooltip input[type=text] {
    display: none;
    border: 1px solid #ccc;
    font-size: 16px;
    height: 26px;
    margin: 0px;
    padding: 3px 5px;
    width: 170px;
}

.ql-snow .ql-tooltip a.ql-preview {
    display: inline-block;
    max-width: 200px;
    overflow-x: hidden;
    text-overflow: ellipsis;
    vertical-align: top;
}

.ql-snow .ql-tooltip a.ql-action::after {
    border-right: 1px solid #ccc;
    content: 'Edit';
    margin-left: 16px;
    padding-right: 8px;
}

.ql-snow .ql-tooltip a.ql-remove::before {
    content: 'Remove';
    margin-left: 8px;
}

.ql-snow .ql-tooltip a {
    line-height: 26px;
}

.ql-snow .ql-tooltip.ql-editing a.ql-preview,
.ql-snow .ql-tooltip.ql-editing a.ql-remove {
    display: none;
}

.ql-snow .ql-tooltip.ql-editing input[type=text] {
    display: inline-block;
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: 'Save';
    padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode=link]::before {
    content: "Enter link:";
}

.ql-snow .ql-tooltip[data-mode=formula]::before {
    content: "Enter formula:";
}

.ql-snow .ql-tooltip[data-mode=video]::before {
    content: "Enter video:";
}

.ql-snow a {
    color: #06c;
}

.ql-container.ql-snow {
    border: 1px solid #b0b4b4;
    border-bottom-left-radius: 3px !important;
    border-bottom-right-radius: 3px !important;
}

.ql-formats > button {
    box-shadow: none !important;
}

.ql-textLowerCase {
    visibility: hidden;
    position: relative;
}

.ql-textLowerCase::after {
    position: absolute;
    display: block;
    top: 0;
    visibility: visible;
}
</style>
